import React, { useState } from "react";
import moment from "moment";

import WithdrawConfirmation from "../WithdrawConfirmation/WithdrawConfirmation";
import BankAccountConfirmation from "../BankAccountConfirmation/BankAccountConfirmation";
import ConfirmationActions from "@apps/MessageApp/components/ConfirmationActions/ConfirmationActions";
import PlainCounter from "@appComponents/components/PlainCounter/PlainCounter";

import IConfirmation from "./IConfirmation";
import * as style from "./ConfirmationStyle.module.scss";
import { setFundsData } from "@funds/features/action.funds";
import { connect } from "react-redux";
import { TReducers } from "@features/reducers";

const Confirmation: React.FunctionComponent<IConfirmation> = (props) => {
  const [goodbyeVisible, setGoodbyeVisible] = useState(false);
  const { data } = props;

  const bankAccountConfirmatinOnSuccess = (value: boolean) => {
    props.setFundsData(props.investorId);
    setGoodbyeVisible(value);
  };

  const renderContent = (): JSX.Element => {
    if (!goodbyeVisible) {
      if (data?.event_type === "withdraw_confirmation") {
        return (
          <>
            <WithdrawConfirmation
              withdrawId={data.resource_id}
              withdrawPath={data.resource_path}
            />
            <ConfirmationActions
              onError={props.setError}
              onSuccess={setGoodbyeVisible}
              red={"left"}
              token={data.token}
            />
          </>
        );
      }

      if (data?.event_type === "bank_account_confirmation") {
        return (
          <>
            <BankAccountConfirmation bank_account_path={data.resource_path} />
            <ConfirmationActions
              onError={props.setError}
              onSuccess={bankAccountConfirmatinOnSuccess}
              red={"left"}
              token={data.token}
            />
          </>
        );
      }
    }

    return (
      <div className={style.notice}>
        Thank you for your answer, you will be redirected to your BnkToTheFuture
        profile in:&nbsp;
        <PlainCounter
          timeLeft={moment().add(5, "second").toString()}
          onComplete={() => (location.href = "/")}
          completedText={"0 sec"}
          abbreviated={true}
          addedClassName={style.counter}
        />
      </div>
    );
  };

  return renderContent();
};

const mapStateToProps = (store: TReducers) => ({
  investorId: store.userInfo.investor_id,
});

const mapDispatchToProps = (dispatch: Function) => ({
  setFundsData: (investorId: number) => dispatch(setFundsData(investorId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);
